import create from './create'

export default {
  namespaced: true,
  modules: {
    create
  }
}
